<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import PermutaCard from './components/PermutaCard.vue';
import LeadPermutaRow from './components/LeadPermutaRow.vue';
import AddPermutaModal from './components/AddPermutaModal.vue';

const store = useStore();
const tab = ref('oferta');
const showAddModal = ref(false);

const acervo = useMapGetter('permutas/getAcervo');
const leads = useMapGetter('permutas/getLeads');
const uiFlags = useMapGetter('permutas/getUIFlags');

onMounted(() => store.dispatch('permutas/get'));

const acervoCount = computed(() => acervo.value.length);
const leadsCount = computed(() => leads.value.length);

const onModalClose = () => {
  showAddModal.value = false;
};
</script>

<template>
  <div class="flex flex-col h-full w-full overflow-auto p-6 gap-4">
    <div class="flex items-center justify-between">
      <h1 class="text-xl font-extrabold text-n-slate-12">Permutas</h1>
      <button
        class="inline-flex items-center gap-1.5 px-3 h-9 rounded-xl bg-n-brand text-white text-sm font-semibold hover:opacity-90 transition-opacity"
        @click="showAddModal = true"
      >
        + Adicionar permuta
      </button>
    </div>

    <div class="flex gap-4 border-b border-n-weak pb-0">
      <button
        class="pb-2 text-sm font-medium transition-colors border-b-2 -mb-px"
        :class="
          tab === 'oferta'
            ? 'text-n-brand border-n-brand'
            : 'text-n-slate-11 border-transparent'
        "
        @click="tab = 'oferta'"
      >
        Imóveis que aceitam ({{ acervoCount }})
      </button>
      <button
        class="pb-2 text-sm font-medium transition-colors border-b-2 -mb-px"
        :class="
          tab === 'demanda'
            ? 'text-n-brand border-n-brand'
            : 'text-n-slate-11 border-transparent'
        "
        @click="tab = 'demanda'"
      >
        Leads que oferecem ({{ leadsCount }})
      </button>
    </div>

    <div
      v-if="uiFlags.isFetching"
      class="flex items-center justify-center py-12 text-n-slate-11 text-sm"
    >
      Carregando…
    </div>

    <template v-else-if="tab === 'oferta'">
      <div
        v-if="acervo.length === 0"
        class="py-12 text-center text-n-slate-11 text-sm"
      >
        Nenhum imóvel com permuta encontrado.
      </div>
      <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <PermutaCard
          v-for="p in acervo"
          :key="p.source + p.code"
          :permuta="p"
        />
      </div>
    </template>

    <template v-else>
      <p class="text-xs text-n-slate-10 -mt-1">
        Leads que sinalizaram aceitar permuta. Cruze o que cada um oferece e busca com o acervo ao lado.
      </p>
      <div
        v-if="leads.length === 0"
        class="py-12 text-center text-n-slate-11 text-sm"
      >
        Nenhum lead oferecendo permuta encontrado.
      </div>
      <div v-else class="flex flex-col gap-3">
        <LeadPermutaRow v-for="l in leads" :key="l.conversation_id" :lead="l" />
      </div>
    </template>

    <AddPermutaModal v-if="showAddModal" @close="onModalClose" />
  </div>
</template>
